module.exports = __webpack_public_path__ + "client/cad/assets/center-cut-safe.png";